var map = {
	"./bg-error.jpg": 489,
	"./catlogo.png": 7608,
	"./error.png": 375,
	"./krka_full.webp": 8076,
	"./page-title.jpg": 2580,
	"./plitvice_full.webp": 7282,
	"./services-single.jpg": 5999,
	"./trogir_full.webp": 3269,
	"./typo.jpg": 2988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2215;